// src/components/react-table/CellDate.tsx

import { Typography } from '@mui/material'

import { DDMMYYYYHHMMSS, userLocales } from '../../api'

export const CellDate = row => (
  <Typography sx={{ width: 200 }}>
    {new Date(row.value).toLocaleDateString(userLocales, DDMMYYYYHHMMSS)}
  </Typography>
)
